import Vue from "vue";
import { NewsSummary } from "@/components/News"
import { mapGetters } from "vuex"
import { LoadingSpinner } from "@/components"

export default Vue.extend({
    name: "NewsStories",
    components: { 
        NewsSummary, 
        LoadingSpinner 
    },
    computed: {
        ...mapGetters(["getContentItem"]),
    },
    props: {
        newsStories: Array,
        isLoading: Boolean
    },
    methods: {
        loadNewsStory(storyId: Number) {
            this.$emit("load-story", storyId);
        }
    }
});